import styled from 'styled-components';
import withImage from '../../../../shared/components/utils/hoc/withImage';
import Screen from '../../../../shared/utils/screen';

/**
 * Styled image component for channel logo in pause ad modal.
 * Displays the white version of the channel logo.
 */
const PauseAdEventChannelLogo = styled.img<React.CSSProperties>`
  width: ${80 * Screen.widthRatio}px;
  height: ${80 * Screen.widthRatio}px;
`;

export default withImage(PauseAdEventChannelLogo, false);
